import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-documento',
  templateUrl: './form-documento.component.html',
  styleUrls: ['./form-documento.component.css']
})
export class FormDocumentoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
